interface IPromotionBanner {
  bannerId: number;
  bannerImageUrl: string;
}

class PromotionBanner {
  constructor(args: IPromotionBanner) {
    return Object.assign(this, args);
  }
}

interface PromotionBanner extends IPromotionBanner {
}

export default PromotionBanner;